// >>> Helper: read stored otpRedirect safely
function __getStoredOtpRedirect() {
    try {
        const url = sessionStorage.getItem("otpRedirect");
        if (!url) return null;
        const consumed = sessionStorage.getItem("otpRedirectConsumed") === "1";
        const isOneShot = /[?&]reload=1\b/.test(url);
        if (consumed && isOneShot) return null;
        // same-origin guard
        if (!(url.startsWith("/") || url.startsWith(location.origin))) return null;
        return url;
    } catch { return null; }
}

// >>> Helper: mark one-shot redirect as consumed
function __consumeOtpRedirectIfOneShot(url) {
    try {
        if (url && /[?&]reload=1\b/.test(url)) {
            sessionStorage.setItem("otpRedirectConsumed", "1");
        }
    } catch { }
}


// >>> Core: decide where to go after successful login
function resolvePostLoginTarget() {
    try {
        // 0) Highest priority: explicit modal source
        const otpSource = sessionStorage.getItem('otpSource') || '';
        // Normalize
        const src = String(otpSource).trim().toLowerCase();

        // If opened from header account icon -> go to /account
        if (src === 'account_icon' || src === 'account') {
            return { target: '/account', consume: false };
        }

        // If wishlist click set a special source, prefer wishlist
        if (src === 'wishlist_click' || src === 'wishlist_landing' || sessionStorage.getItem('otpOpenedFromWishlistClick') === '1') {
            // honour explicit otpRedirect if present, else wishlist
            const stored = __getStoredOtpRedirect();
            return { target: stored || '/pages/wishlist', consume: true };
        }

        // 1) explicit otpRedirect set by modal openers (wishlist, product, plp, jf, etc.)
        const otpRedirect = __getStoredOtpRedirect();
        if (otpRedirect) return { target: otpRedirect, consume: true };

        // 1.5) header account icon fallback (in case source not set but we have a cookie or other flag)
        // (kept for backward compatibility)
        // if session flag exists but wasn't read earlier, still handle:
        try {
            if (sessionStorage.getItem('otpSource') === 'account_icon') {
                return { target: '/account', consume: false };
            }
        } catch (_) {}

        // 2) cart scenario
        const fromCart = sessionStorage.getItem('otpOpenedFromCart') === 'true';
        if (fromCart) return { target: "/checkout", consume: false };

        // 3) fallback to referrer (same-origin only)
        if (document.referrer && document.referrer.startsWith(location.origin)) {
            try {
                const here = location.pathname + location.search;
                const back = new URL(document.referrer);
                // avoid bouncing to /account loops
                if (back.pathname.replace(/\/+$/, "") !== "/account" && (back.pathname + back.search) !== here) {
                    return { target: back.pathname + back.search, consume: false };
                }
            } catch { }
        }

        // 4) default home
        return { target: "/", consume: false };
    } catch (e) {
        console.warn('resolvePostLoginTarget error', e);
        return { target: "/", consume: false };
    }
}

function setLoginFormReturnTo(formEl) {
    const { target, consume } = resolvePostLoginTarget();

    // Mark reload-type redirects as consumed
    if (consume) __consumeOtpRedirectIfOneShot(target);

    // Clean cart flag
    try { sessionStorage.removeItem('otpOpenedFromCart'); } catch { }

    // Also clear wishlist click flag once used
    try { sessionStorage.removeItem('otpOpenedFromWishlistClick'); } catch {}

    // Write a short-lived cookie fallback (15 min)
    try {
        if (target) {
            document.cookie = `rt=${encodeURIComponent(target)}; Path=/; Max-Age=900; SameSite=Lax`;
        }
    } catch { }

    // Ensure the hidden return_to field exists and gets updated
    let rt = formEl.querySelector('input[name="return_to"]');
    if (!rt) {
        rt = document.createElement('input');
        rt.type = 'hidden';
        rt.name = 'return_to';
        formEl.appendChild(rt);
    }
    rt.value = target || "/";

    // Keep a clean action attribute — Shopify will respect hidden input too
    formEl.action = "/account/login";

    return target;
}


// -------------------- OTP state --------------------
let otpVerified = false;
let lastVerifiedOtp = null;
let lastOtpResponse = null;
window.isEmailOtpVerified = false;
let currentOtpChannel = "sms";

let otpExpiryTimeoutId = null; // will hold the 60s timeout id
let otpGuard = 0; // changes each time we start a fresh OTP flow
let lastTrackedLoginPhone = "";
let lastTrackedEnteredOtp = "";

function cancelOtpTimers() {
    // Invalidate any pending timeout/callbacks from previous flows
    otpGuard = otpGuard + 1;

    // Clear the 60s expiry timeout if it exists
    try {
        if (otpExpiryTimeoutId) {
            clearTimeout(otpExpiryTimeoutId);
            otpExpiryTimeoutId = null;
        }
    } catch (e) { otpExpiryTimeoutId = null; }

    // Clear the visible countdown interval if it exists
    try {
        if (typeof countdownInterval !== "undefined" && countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
    } catch (e) { countdownInterval = null; }
}

function getOtpChannelLabel(channel) {
    return (channel === "whatsapp") ? "WhatsApp" : "SMS";
}

function updateOtpBanner(phone, channel) {
    const channelLabel = getOtpChannelLabel(channel);
    jQuery(".ct_edit_number").html(`
    Check ${channelLabel} for OTP at
    <span class="ct_mobile_no_wrap">
      <span class="ct_mobile_no">+91-${phone}</span>
      <span class="ct_edit_icon">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M0.792882 8.36974L0.0276978 10.4102C-0.00168484 10.4887 -0.00784389 10.574 0.00995646 10.656C0.0277568 10.7379 0.0687641 10.813 0.128081 10.8722C0.187398 10.9315 0.262517 10.9724 0.344467 10.9901C0.426417 11.0079 0.511735 11.0016 0.59023 10.9721L2.63014 10.207C2.86362 10.1195 3.07568 9.98312 3.25207 9.80692L9.16099 3.89808C9.16099 3.89808 8.95485 3.28023 8.33757 2.66239C7.7203 2.04512 7.10187 1.83898 7.10187 1.83898L1.19294 7.74782C1.01674 7.9242 0.880329 8.13626 0.792882 8.36974ZM7.92587 1.01499L8.73123 0.209639C8.87565 0.0652232 9.0684 -0.026784 9.26989 0.00699076C9.55349 0.0535766 9.98732 0.194499 10.3961 0.603872C10.8055 1.01325 10.9464 1.44649 10.993 1.73009C11.0268 1.93157 10.9348 2.12432 10.7904 2.26874L9.98441 3.07409C9.98441 3.07409 9.77885 2.45683 9.16099 1.83956C8.54372 1.22114 7.92587 1.01499 7.92587 1.01499Z" fill="#0076C6"/>
        </svg>
      </span>
    </span>
  `);
}


// -------------------- DOM ready handlers --------------------
jQuery(document).ready(function () {
    jQuery("input, select, textarea,email,password,tel").each(function (index) {
        const input = jQuery(this);
        input.on("focus", function () {
            jQuery(this).parent().addClass("has-focus");
        });

        input.on("focusout", function () {
            if (jQuery(this).val() == "") {
                jQuery(this).parent().removeClass("has-focus");
            }
        });
    });

    jQuery('input[type="text"],input[type="email"],input[type="password"],input[type="tel"],input[type="search"], select, textarea')
        .each(function (index) {
            const input = jQuery(this);
            if (input.val() == "") {
                jQuery(input).parent().removeClass("has-focus");
            } else {
                jQuery(input).parent().addClass("has-focus");
            }
    });

    jQuery(document).on("input", ".ct_active.ct_mobile", function (e) {
        const $input = jQuery(this);
        let value = $input.val().replace(/\D/g, ""); // Remove non-digit characters

        // Ensure input only contains a maximum of 10 digits
        if (value.length > 10) {
            value = value.slice(0, 10);
        }

        $input.val(value);

        setTimeout(function () {
            const firstDigit = parseInt(value[0], 10);

            if (isNaN(firstDigit)) {
                // nothing
            } else {
                // Check the first digit condition
                if (firstDigit <= 5) {
                    jQuery(".ct_mobile").addClass("ct_error");
                    jQuery(".ct_no_error").show();
                } else {
                    if (value.length !== 10) {
                        jQuery(".notify_me").attr("disabled", "disabled"); // Disable the button
                        jQuery(".ct_mobile").removeClass("ct_error");
                        jQuery(".ct_no_error").hide();
                    } else if (value.length === 10) {
                        jQuery('.notify_me').removeAttr('disabled');
                        jQuery(".ct_mobile").removeClass("ct_error");
                        jQuery(".ct_no_error").hide();
                        if (value !== lastTrackedLoginPhone) {
                            try {
                                clevertap.event.push("User_Details_Entered", {
                                    Phone: "+91" + value
                                });
                                lastTrackedLoginPhone = value;
                            } catch (e) { }
                        }
                        try {
                            if (sessionStorage.getItem("otpOpenedFromCart") === "true") {
                                clevertap.event.push("Login_Popup_Opened", {
                                    Scenario: "acount_icon"
                                });
                            }
                        } catch (e) { }
                    }
                }
            }
        }, 100);

        // Prevent non-numeric input
        const charCode = e.which ? e.which : (window.event ? window.event.keyCode : 0);
        if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
            jQuery(".ct_no_error").hide();
            return false;
        }
    });

    jQuery(document).on("input", ".ct_text", function (e) {
        const $input = jQuery(this);
        let value = $input.val().replace(/\D/g, ""); // Remove non-digit characters

        // Ensure input only contains a maximum of 4 digits
        if (value.length > 4) {
            value = value.slice(0, 4);
        }

        $input.val(value);

        setTimeout(function () {
            // Check the length condition
            if (value.length !== 4) {
                jQuery(".verify").attr("disabled", "disabled"); // Disable the button
            } else {
                jQuery('.verify').removeAttr('disabled');
                if (value !== lastTrackedEnteredOtp) {
                    try {
                        clevertap.event.push("OTP_Entered", {
                            OTP: value
                        });
                        lastTrackedEnteredOtp = value;
                    } catch (err) { }
                }
            }
        }, 100);

        // Prevent non-numeric input
        const charCode = e.which ? e.which : (window.event ? window.event.keyCode : 0);
        if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
            jQuery(".ct_no_error").hide();
            return false;
        }
    });

    jQuery(document).on("click", ".ct_btn_wrap .ct_change_type", function () {
        const ct_type = jQuery(this).attr("data-type");
        jQuery(".ct_change_type").removeClass("ct_active");
        jQuery(this).addClass("ct_active");
    });

    jQuery(".notify_me").click(function () {
        // Always hide and clear final signup form at the top
        jQuery(".ct_final_signup")
            .hide()
            .removeClass("ct_signup_shown")
            .find("input")
            .val("")
            .trigger("focusout");

        const mobile_no = jQuery(".ct_active.ct_type").val();
        const cust_contact_no_length = jQuery(".ct_active.ct_type").val().length;
        const flag_check = (cust_contact_no_length === 10);

        if (flag_check) {
            const data = {
                mobile_no: mobile_no,
                method_call: "send_otp"
            };
            jQuery(".rb_checking_status").text("Sending OTP ...");
            jQuery(".rb_checking_status").show();

            jQuery.ajax({
                url: "https://gifting.kushals.com/accessIn/inside.php",
                cache: false,
                type: "POST",
                data: data,
                dataType: "json",
                success: function (obj) {
                    if (obj && obj.success) {
                        jQuery(".rb_checking_status").text("");
                        jQuery(".rb_checking_status").hide();
                        jQuery(".ct_wrap_login").attr("data-phone", mobile_no);
                        jQuery(".ct_wrap_login").hide();
                        jQuery(".ct_final_signup").hide();
                        jQuery(".ct_final_signup input").val("").trigger("focusout");
                        jQuery(".wrap_verify ").show();
                        setOtpChannelPickerMode(false);
                        jQuery("#otp-channel-picker").hide();
                        jQuery(".ct_wrap_verify_main").removeClass("otp-continue-mode");
                        jQuery(".ct_login_error").text("");
                        resendOtpCount = 0;
                        jQuery('.ct-continue-without-login').hide();
                        jQuery('.verify').show();
                        jQuery('.ct_resend_btn').show();
                        jQuery(".ct_mobile_no_wrap .ct_mobile_no").text('+91-' + mobile_no);
                        currentOtpChannel = "sms";
                        updateOtpBanner(mobile_no, currentOtpChannel);

                        // start countdown
                        const timeLeft = 59;
                        startCountdown(timeLeft);

                        try {
                            clevertap.profile.push({
                                "Site": {
                                    "Phone": "+91" + mobile_no,
                                    "MSG-email": false,
                                    "MSG-push": true,
                                    "MSG-sms": true,
                                    "MSG-whatsapp": true
                                }
                            });
                            clevertap.event.push("Login_Details_Submitted", {
                                Phone: "+91" + mobile_no
                            });
                            setTimeout(function () {
                                clevertap.event.push("otp_sent", {
                                    "Phone": "+91" + mobile_no
                                });
                            }, 1000);
                        } catch (e) { }

                        // Step 2: guarded 60s expiry timeout (prevents stale callbacks)
                        const myGuard = otpGuard + 1;
                        otpGuard = myGuard;
                        otpExpiryTimeoutId = setTimeout(function () {
                            if (myGuard !== otpGuard) return;
                            try {
                                if (jQuery(".wrap_verify").is(":visible")) {
                                    resetOtpModalToPhoneInput();
                                }
                            } catch (e) { }
                        }, 130000);
                    } else {
                        jQuery(".rb_checking_status").hide();
                        jQuery(".rb_checking_status").text("");
                        jQuery(".ct_login_error").text((obj && obj.msg) ? obj.msg : "Failed to send OTP");
                    }
                },
                error: function () {
                    jQuery(".rb_checking_status").hide();
                    jQuery(".rb_checking_status").text("");
                    jQuery(".ct_login_error").text("Network error while sending OTP");
                }
            });
        } else {
            jQuery(".ct_no_error").show();
        }
    });

    // Verify the OTP
    jQuery(".verify").click(function () {
        cancelOtpTimers();
        const otp = jQuery(".ct_text").val();
        const mobile_no = jQuery(".ct_wrap_login").attr("data-phone");
        const scenario = (sessionStorage.getItem("otpOpenedFromCart") === "true") ? "cart_login" : "login_modal";

        if (otpVerified && otp === lastVerifiedOtp) {
            try {
                if (typeof handleLoginSuccess === "function") {
                    handleLoginSuccess(lastOtpResponse);
                }
            } catch (e) { }
            return;
        }

        const data = {
            otp: otp,
            mobile_no: mobile_no,
            method_call: "verify_otp"
        };

        if (typeof showLoader === "function") showLoader();

        jQuery.ajax({
            url: "https://gifting.kushals.com/accessIn/inside.php",
            cache: false,
            type: "POST",
            data: data,
            dataType: "json",
            success: function (obj) {
                if (typeof closeLoader === "function") closeLoader();

                // define mobile_no again
                const mobile_no_local = jQuery(".ct_wrap_login").attr("data-phone");

                if (obj && obj.success) {
                    jQuery(".ct_edit_number").text("OTP Verified Successfully.");
                    try { clevertap.event.push("otp_verified"); } catch (e) { }

                    setTimeout(function () {
                        try {
                            clevertap.event.push("Login", {
                                Method_Used: "shopify",
                                Login_Status: "success",
                                Phone: mobile_no_local
                            });
                        } catch (e) { }
                    }, 1000);

                    if (obj.need_email === true && obj.customer_id) {
                        showFinalSignupForPhoneOnly(mobile_no_local, obj.customer_id);
                        return;
                    }

                    if ((!obj.p || !obj.e) && !obj.guest_login && !obj.need_email) {
                        jQuery(".ct_wrap_verify_main").hide();
                        jQuery(".ct_final_signup").show();
                        try { sessionStorage.setItem("login_mobile", mobile_no_local); } catch (e) { }
                        return;
                    }

                    if (obj.guest_login) {
                        jQuery(".ct_wrap_verify_main").hide();
                        jQuery(".ct_wrap_success_main").show();
                        jQuery("#rb_active_password").val("123456");
                        jQuery("#rb_activation_confirm_password").val("123456");
                        jQuery("#rb_activation_token").val(obj.cust_url);
                        jQuery("#rb_active_customer").val(obj.id);
                        jQuery("#rb_customer_activation_form button").trigger("click");
                    } else {
                        // Existing customer path
                        jQuery(".ct_wrap_verify_main").hide();
                        jQuery(".ct_wrap_success_main").show();

                        const pass = decode(obj.p);
                        const email = decode(obj.e);

                        const ct_token = obj.t;
                        jQuery("#ct_CustomerEmail").val(email);
                        jQuery("#ct_CustomerPassword").val(pass);

                        // Set a cookie and local storage
                        try { setCookie("ct_token", ct_token, "2"); } catch (e) { }
                        try { sessionStorage.setItem("ct_token", ct_token); } catch (e) { }
                        try { localStorage.setItem("ct_token", ct_token); } catch (e) { }

                        // Instead of form.submit(), use AJAX helper to avoid adding history entry
                        let fromCart = false;
                        try {
                            fromCart = (sessionStorage.getItem('otpOpenedFromCart') === 'true');
                            if (fromCart) sessionStorage.removeItem('otpOpenedFromCart');
                        } catch (e) { fromCart = false; }

                        // call the helper
                        try {
                            if (typeof ajaxSubmitLoginAndReload === "function") {
                                ajaxSubmitLoginAndReload(email, pass, fromCart);
                            } else {
                                const form = document.getElementById('ct_customer_login');
                                if (form) {
                                    if (fromCart) form.action = "/account/login?return_to=/checkout";
                                    else form.action = "/account/login";
                                    form.submit();
                                }
                            }
                        } catch (e) {
                            const formFallback = document.getElementById('ct_customer_login');
                            if (formFallback) {
                                if (fromCart) formFallback.action = "/account/login?return_to=/checkout";
                                else formFallback.action = "/account/login";
                                formFallback.submit();
                            }
                        }
                    }
                } else {
                    const reasonText = (obj && (obj.msg || obj.message)) || "Invalid OTP";
                    try {
                        clevertap.event.push("otp_login_failure", {
                            Phone: mobile_no_local,
                            Reason: reasonText,
                            Scenario: scenario
                        });
                    } catch (e) { }

                    showOtpError();
                }
            },
            error: function () {
                if (typeof closeLoader === "function") closeLoader();
                showOtpError();
            }
        });
    });


    // end of ready()
});

// ---- countdown interval global
let countdownInterval;

function showContinueWithoutLoginState() {
    setOtpChannelPickerMode(false);
    jQuery(".ct_wrap_verify_main").addClass("otp-continue-mode");
    jQuery('.ct-continue-without-login').show();
    jQuery('#resend-otp').hide();
    jQuery('#timer-display').hide();
    jQuery(".ct_edit_number").text("There was an issue sending your OTP. Please try again in a moment.");
    jQuery('.verify').hide();
    jQuery('.ct_resend_btn').hide();
    jQuery(".otp-clear").hide();
}

function startCountdown(timeLeft) {
    // Clear any previous interval
    try {
        if (countdownInterval) {
            clearInterval(countdownInterval);
        }
    } catch (e) { }

    countdownInterval = setInterval(function () {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        const secondsStr = (seconds < 10) ? ("0" + seconds) : ("" + seconds);

        // Update the display
        jQuery("#timer-display").text("Resend in " + secondsStr + " seconds");

        timeLeft--;

        if (timeLeft < 0) {
            try {
                clearInterval(countdownInterval);
                countdownInterval = null;
                jQuery("#timer-display").hide();
                jQuery("#resend-otp").show();
            } catch (e) { }
        }
    }, 1000);
}

// Clear the interval on click
jQuery(".ct_mobile_no_wrap").click(function () {
    try {
        if (countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
    } catch (e) { countdownInterval = null; }

    jQuery(".ct_mobile_no").text("");
    jQuery(".ct_mobile").text("");
    jQuery(".ct_wrap_verify_main").hide();
    jQuery(".ct_final_signup").hide();
    jQuery(".ct_final_signup input").val("").trigger("focusout");
    jQuery(".ct_wrap_login").show();
    const phoneInput = document.querySelector(".ct_pre_no_main");
    if (phoneInput) phoneInput.value = "";
});


// resend-otp click
let resendOtpCount = 0;

function setOtpChannelPickerMode(enabled) {
    const modalContent = document.querySelector(".ct-otp-modal-content");
    if (enabled) {
        jQuery(".ct_wrap_verify_main").addClass("otp-channel-mode");
        if (modalContent) modalContent.classList.add("otp-channel-no-scroll");
    } else {
        jQuery(".ct_wrap_verify_main").removeClass("otp-channel-mode");
        if (modalContent) modalContent.classList.remove("otp-channel-no-scroll");
    }
}



jQuery(document).on("click", "#resend-otp", function () {
    if (typeof cancelOtpTimers === "function") {
        cancelOtpTimers();
    }
    resetOtpErrorState();

    // On third resend click, skip channel chooser and show continue-without-login directly.
    if (resendOtpCount >= 2) {
        setOtpChannelPickerMode(false);
        jQuery("#otp-channel-picker").hide();
        showContinueWithoutLoginState();
        return;
    }

    setOtpChannelPickerMode(true);
    jQuery("#otp-channel-picker").show();
    jQuery("#resend-otp").hide();
});

function sendOtpViaSelectedChannel(channel) {
    const mobile_no = jQuery(".ct_wrap_login").attr("data-phone");
    if (!mobile_no) return;
    const picker = jQuery("#otp-channel-picker");
    let pickerError = picker.find(".ct_login_error");
    if (!pickerError.length) {
        pickerError = jQuery('<span class="ct_login_error"></span>');
        picker.append(pickerError);
    }
    pickerError.css({
        display: "block",
        marginTop: "10px",
        textAlign: "center"
    });
    pickerError.text("");

    resendOtpCount++;
    const otpInput = document.querySelector(".ct_text");
    if (otpInput) otpInput.value = "";

    const data = {
        mobile_no: mobile_no,
        method_call: (channel === "whatsapp") ? "send_whatsapp_otp" : "send_otp"
    };

    if (typeof showLoader === "function") {
        showLoader();
    }

    jQuery.ajax({
        url: "https://gifting.kushals.com/accessIn/inside.php",
        cache: false,
        type: "POST",
        data: data,
        dataType: "json",
        success: function (obj) {
            if (typeof hideLoader === "function") {
                hideLoader();
            } else if (typeof closeLoader === "function") {
                closeLoader();
            }

            if (obj && obj.success) {
                currentOtpChannel = (channel === "whatsapp") ? "whatsapp" : "sms";
                try {
                    clevertap.event.push("Login_Details_Submitted", {
                        Phone: "+91" + mobile_no
                    });
                    setTimeout(function () {
                        clevertap.event.push("otp_sent", {
                            Phone: "+91" + mobile_no,
                            Chanel: currentOtpChannel,
                            IsResend: true
                        });
                    }, 1000);
                    clevertap.event.push("otp_resend", {
                        Phone: "+91" + mobile_no,
                        Chanel: currentOtpChannel
                    });
                } catch (e) { }
                updateOtpBanner(mobile_no, currentOtpChannel);
                pickerError.text("");
                setOtpChannelPickerMode(false);
                jQuery(".ct_wrap_verify_main").removeClass("otp-continue-mode");
                jQuery("#otp-channel-picker").hide();
                jQuery("#resend-otp").hide();
                const timeLeft = 60;
                startCountdown(timeLeft);
                jQuery("#timer-display").show();
            } else {
                pickerError.text((obj && obj.msg) ? obj.msg : "Failed to send OTP");
            }
        },
        error: function () {
            if (typeof hideLoader === "function") {
                hideLoader();
            } else if (typeof closeLoader === "function") {
                closeLoader();
            }

            pickerError.text("Network error while sending OTP");
        }
    });
}

jQuery(document).on("click", ".otp-channel-btn", function () {
    const channel = jQuery(this).data("channel");
    sendOtpViaSelectedChannel(channel);
});

function updateOtpButtonState() {
    const phoneValEl = jQuery('.ct_mobile')[0];
    const phoneVal = phoneValEl ? jQuery('.ct_mobile').val().trim() : "";
    const isPhoneValid = (/^[6-9]\d{9}$/).test(phoneVal);
    const isChecked = true;
    if (isPhoneValid && isChecked) {
        jQuery('.notify_me').removeAttr('disabled');
    } else {
        jQuery('.notify_me').attr('disabled', 'disabled');
    }
}

// Run on phone input and checkbox change
jQuery(document).on('input', '.ct_mobile', updateOtpButtonState);
jQuery(document).on('change', '#otp_terms_checkbox', updateOtpButtonState);

function showOtpError() {
    jQuery('.ct_text').css({
        border: '1px solid #D82953',
        color: '#D82953'
    });

    jQuery('.otp-clear svg circle').attr('fill', '#D82953');
    jQuery('.otp-clear').show();
    jQuery('.otp-success').hide();

    jQuery('.ct_edit_number').html('<span style="color: #454545;">Please enter a valid OTP</span>');

    jQuery('.verify').attr('disabled', 'disabled');
    jQuery("#timer-display").hide();
    jQuery("#resend-otp").show();
}

jQuery(document).on("click", ".ct_mobile_no_wrap", function () {
    cancelOtpTimers();

    jQuery(".wrap_verify").hide();
    jQuery(".ct_wrap_verify_main").hide();
    jQuery(".ct_final_signup").hide();
    jQuery(".ct_final_signup input").val("").trigger("focusout");
    jQuery(".ct_wrap_success_main").hide();
    try { sessionStorage.removeItem("login_mobile"); } catch (e) { }

    jQuery(".ct_wrap_login").not(".ct_final_signup").show();

    // Clear mobile input completely
    jQuery(".ct_active.ct_type").val("").focus();

    const phone = jQuery(".ct_mobile_no").text().trim();
    jQuery(".ct_active.ct_type").val("").focus();

    jQuery(".ct_text").val("").removeClass("ct_error");
    jQuery(".verify").attr("disabled", "disabled");
    jQuery(".ct_login_error").text("");
    jQuery(".ct_no_error").hide();
    jQuery("#resend-otp").hide();
    jQuery("#timer-display").hide();
    jQuery(".otp-clear").hide();
    jQuery(".otp-success").hide();

    jQuery(".ct_mobile_no").text(phone);
    jQuery(".ct_edit_number").show();
    jQuery("#timer-display").show();
    jQuery(".notify_me").attr("disabled", "disabled");
});

jQuery(document).on('click', '.ct-continue-without-login', function () {
    try { clevertap.event.push("continue_without_login_initiated"); } catch (e) { }

    cancelOtpTimers();

    let fromCart = false;
    try { fromCart = (sessionStorage.getItem('otpOpenedFromCart') === 'true'); } catch (e) { fromCart = false; }

    if (fromCart) {
        try { sessionStorage.removeItem('otpOpenedFromCart'); } catch (e) { }
        window.location.href = "/checkout";
    } else {
        if (typeof hideOtpModal === "function") hideOtpModal();
    }
});

jQuery(".ct_mobile_no_wrap").on("click", function () {
    resendOtpCount = 0;
    jQuery('.ct-continue-without-login').hide();
});

function showEmailOtpError() {
    const input = document.querySelector(".signup-email-otp");
    const errorText = document.querySelector(".email-otp-error");
    const clearIcon = document.querySelector(".email-otp-clear");

    if (input) {
        input.style.border = "1px solid #D82953";
        input.style.color = "#D82953";
    }

    if (errorText) errorText.style.display = "block";
    if (clearIcon) clearIcon.style.display = "block";
}

let emailOtpTimer;
let emailOtpCountdown = 30;
let emailOtpResendCount = 0;

function startEmailOtpTimer() {
    const resendBtn = document.querySelector('#resend-email-otp');
    const timerSpan = document.querySelector('#email-timer-display');

    if (!resendBtn) return;

    try { clearInterval(emailOtpTimer); } catch (e) { }

    resendBtn.style.display = 'none';
    resendBtn.style.cursor = 'not-allowed';

    emailOtpCountdown = 30;
    if (timerSpan) {
        timerSpan.style.display = 'block';
        timerSpan.innerText = 'Resend in ' + emailOtpCountdown + ' seconds';
    }

    emailOtpTimer = setInterval(function () {
        emailOtpCountdown--;
        if (emailOtpCountdown <= 0) {
            clearInterval(emailOtpTimer);
            resendBtn.style.display = 'block';
            resendBtn.style.cursor = 'pointer';
            if (timerSpan) {
                timerSpan.innerText = '';
                timerSpan.style.display = 'none';
            }
        } else {
            if (timerSpan) {
                timerSpan.innerText = 'Resend in ' + emailOtpCountdown + ' seconds';
            }
        }
    }, 1000);
}

function showContinueWithoutLoginFromEmailOtp() {
    try { clearInterval(emailOtpTimer); } catch (e) { }
    emailOtpTimer = null;

    const timerSpan = document.querySelector('#email-timer-display');
    if (timerSpan) {
        timerSpan.innerText = '';
        timerSpan.style.display = 'none';
    }

    jQuery(".ct_final_signup").hide();
    jQuery(".ct_wrap_verify_main").show();
    showContinueWithoutLoginState();
}

document.addEventListener('DOMContentLoaded', function () {
    const otpBlock = document.querySelector('.signup-email-otp-block');
    const resendWrap = document.querySelector('.email-otp-resend-wrap');

    if (otpBlock && resendWrap) {
        const observer = new MutationObserver(function () {
            if (otpBlock.style.display !== 'none') {
                resendWrap.style.display = 'block';
                startEmailOtpTimer();
            }
        });

        observer.observe(otpBlock, {
            attributes: true,
            attributeFilter: ['style']
        });
    }
});

jQuery(document).on('click', '#resend-email-otp', function () {
    const resendBtn = document.querySelector('#resend-email-otp');
    const emailEl = document.querySelector('.signup-email');
    const email = emailEl ? (emailEl.value || "").trim() : "";
    const phone = sessionStorage.getItem('login_mobile');
    const emailOtpInput = document.querySelector('.signup-email-otp');

    if (emailOtpInput) emailOtpInput.value = "";
    resetEmailOtpState();

    if (emailOtpResendCount >= 1) {
        showContinueWithoutLoginFromEmailOtp();
        return;
    }

    if (!email || !phone) {
        alert("Missing email or phone number");
        return;
    }

    if (resendBtn) {
        resendBtn.style.display = 'none';
        resendBtn.style.cursor = 'not-allowed';
    }
    try { clearInterval(emailOtpTimer); } catch (e) { }

    jQuery.ajax({
        url: "https://gifting.kushals.com/accessIn/inside.php",
        method: "POST",
        dataType: "json",
        data: {
            method_call: "resend_email_otp",
            email: email,
            mobile_no: phone
        },
        success: function (res) {
            let response = res;
            if (typeof response === "string") {
                try { response = JSON.parse(response); } catch (e) { response = null; }
            }

            if (response && response.success) {
                emailOtpResendCount = emailOtpResendCount + 1;
                startEmailOtpTimer();
            } else if (resendBtn) {
                resendBtn.style.display = 'block';
                resendBtn.style.cursor = 'pointer';
            }
        },
        error: function () {
            if (resendBtn) {
                resendBtn.style.display = 'block';
                resendBtn.style.cursor = 'pointer';
            }
        }
    });
});

function resetEmailOtpState() {
    const input = document.querySelector(".signup-email-otp");
    const errorText = document.querySelector(".email-otp-error");
    const clearIcon = document.querySelector(".email-otp-clear");

    if (input) {
        input.style.border = "";
        input.style.color = "";
    }

    if (errorText) errorText.style.display = "none";
    if (clearIcon) clearIcon.style.display = "none";
}

function resetOtpErrorState() {
    jQuery('.ct_text').css({
        border: '1px solid rgba(69, 69, 69, 0.8)',
        color: 'rgba(69, 69, 69, 0.8)'
    });

    jQuery('.otp-clear svg circle').attr('fill', 'rgba(69, 69, 69, 0.8)');
}

jQuery(document).ready(function () {
    jQuery('.ct_text').on('input', function () {
        resetOtpErrorState();
    });
});

function resetOtpModalToPhoneInput() {
    cancelOtpTimers();
    emailOtpResendCount = 0;
    try { clearInterval(emailOtpTimer); } catch (e) { }
    emailOtpTimer = null;
    setOtpChannelPickerMode(false);
    jQuery("#otp-channel-picker").hide();
    jQuery(".ct_wrap_verify_main").removeClass("otp-continue-mode");
    resendOtpCount = 0;
    try {
        if (countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
    } catch (e) { countdownInterval = null; }

    resetOtpErrorState();

    jQuery("#timer-display").show();
    jQuery("#resend-otp").hide();
    jQuery(".ct_mobile_no").text("");
    jQuery('.ct-continue-without-login').hide();
    jQuery('.verify').show();
    jQuery('.ct_resend_btn').show();
    jQuery(".ct_wrap_verify_main").hide();
    jQuery(".ct_final_signup").hide();
    jQuery(".ct_final_signup input").val("").trigger("focusout");
    jQuery(".ct_wrap_login").show().css("display", "flex");

    jQuery(".ct_text").val("");
    jQuery(".otp-clear").hide();
    const phone = jQuery(".ct_wrap_login").attr("data-phone") || sessionStorage.getItem("login_mobile") || "";
    if (phone) updateOtpBanner(phone, currentOtpChannel);

    jQuery(".ct_final_signup")
        .hide()
        .removeClass("ct_signup_shown")
        .find("input")
        .val("")
        .trigger("focusout");
}

function showEmailError() {
    jQuery('.signup-email').css({ border: '1px solid #D82953' });
    jQuery('.signup-email-error').remove();
    jQuery('.signup-email').after(
        '<div class="signup-email-error" style="color:#D82953; font-size:13px; margin-top:4px; text-align: left;">' +
        'Email is already registered with a different phone number.' +
        '</div>'
    );
    jQuery('.signup-submit').attr('disabled', 'disabled').css({ opacity: '0.5', cursor: 'not-allowed' });
}

function resetEmailError() {
    jQuery('.signup-email').css({ border: '' });
    jQuery('.signup-email-error').remove();
    jQuery('.signup-submit').removeAttr('disabled').css({ opacity: '1', cursor: 'pointer' });
}

jQuery('.signup-email').on('input', function () {
    resetEmailError();
});

jQuery("#guestLink").on("click", function (e) {
    try { e.preventDefault(); } catch (err) { }
    try { clevertap.event.push("international_number_guest_checkout"); } catch (e) { }
    const otp = jQuery(".ct_text").val();
    const mobile_no = jQuery(".ct_wrap_login").attr("data-phone");
    const scenario = (sessionStorage.getItem("otpOpenedFromCart") === "true") ? "cart_login" : "login_modal";

    if (scenario === "cart_login") {
        window.location.href = "/checkout";
    } else {
        if (typeof hideOtpModal === "function") hideOtpModal();
    }
});

function showFinalSignupForPhoneOnly(mobile_no, customer_id) {
    emailOtpResendCount = 0;
    try { clearInterval(emailOtpTimer); } catch (e) { }
    emailOtpTimer = null;
    jQuery(".ct_wrap_verify_main").hide();
    jQuery(".ct_final_signup").show();
    try { sessionStorage.setItem("login_mobile", mobile_no); } catch (e) { }
    try { sessionStorage.setItem("customer_id_for_attach", customer_id); } catch (e) { }
}

jQuery(document).on("click", ".signup-submit", function (e) {
    try { e.preventDefault(); } catch (err) { }
    const emailEl = jQuery(".signup-email")[0];
    const email = emailEl ? (jQuery(".signup-email").val() || "").trim() : "";
    const nameEl = jQuery(".signup-name")[0];
    const name = nameEl ? (jQuery(".signup-name").val() || "").trim() : "";
    const mobile_no = sessionStorage.getItem("login_mobile") || jQuery(".ct_wrap_login").attr("data-phone") || "";
    const customer_id = sessionStorage.getItem("customer_id_for_attach") || "";

    if (!email || !mobile_no || !customer_id) {
        return;
    }

    if (typeof showLoader === "function") showLoader();

    jQuery.ajax({
        url: "https://gifting.kushals.com/accessIn/inside.php",
        cache: false,
        type: "POST",
        dataType: "json",
        data: {
            method_call: "final_signup",
            email: email,
            name: name,
            mobile_no: mobile_no,
            customer_id: customer_id
        },
        success: function (res) {
            if (typeof closeLoader === "function") closeLoader();

            if (res && res.success && res.e && res.p) {
                const pass = decode(res.p);
                const mail = decode(res.e);

                jQuery(".ct_wrap_verify_main").hide();
                jQuery(".ct_final_signup").hide();
                jQuery(".ct_wrap_success_main").show();

                jQuery("#ct_CustomerEmail").val(mail);
                jQuery("#ct_CustomerPassword").val(pass);

                try { sessionStorage.removeItem("customer_id_for_attach"); } catch (e) { }

                let fromCartFlag = false;
                try { fromCartFlag = (sessionStorage.getItem('otpOpenedFromCart') === 'true'); } catch (e) { fromCartFlag = false; }
                if (fromCartFlag) {
                    try { sessionStorage.removeItem('otpOpenedFromCart'); } catch (e) { }
                }

                try {
                    if (typeof ajaxSubmitLoginAndReload === "function") {
                        ajaxSubmitLoginAndReload(mail, pass, fromCartFlag);
                        return;
                    }
                } catch (e) { }

                const form = document.getElementById('ct_customer_login');
                if (form) {
                    if (fromCartFlag) form.action = "/account/login?return_to=/checkout";
                    else form.action = "/account/login";
                    form.submit();
                }
                return;
            }

            if (res && res.msg && /already.*in use|already registered/i.test(res.msg)) {
                showEmailError();
                return;
            }

            showEmailError();
        },
        error: function () {
            if (typeof closeLoader === "function") closeLoader();
            showEmailError();
        }
    });
});

// decode helper (unchanged logic)
function decode(data) {
    const key = window.atob(window.atob(window.atob(data)));
    return key;
}

// -------------------- AJAX submit helper (jQuery-based ES5 friendly) --------------------
function ajaxSubmitLoginAndReload(email, password, returnToCheckout) {
    // handle undefined param
    if (typeof returnToCheckout === "undefined") returnToCheckout = false;

    try {
        const body = {
            'form_type': 'customer_login',
            'utf8': '✓',
            'customer[email]': email,
            'customer[password]': password
        };
        if (returnToCheckout) body['return_to'] = '/checkout';

        jQuery.ajax({
            url: '/account/login',
            method: 'POST',
            data: body,
            xhrFields: { withCredentials: true },
            success: function () {
    if (returnToCheckout) {
        window.location.replace('/checkout');
        return;
    }

    // NEW: use resolver (account → /account, wishlist → /pages/wishlist, etc.)
    if (typeof resolvePostLoginTarget === 'function') {
        const resolved = resolvePostLoginTarget();
        if (resolved && resolved.target) {
            if (resolved.consume) __consumeOtpRedirectIfOneShot(resolved.target);
            window.location.replace(resolved.target);
            return;
        }
    }

    // fallback
    window.location.reload();
},

            error: function (xhr, status, err) {
                // fallback to normal form submit if AJAX failed
                try {
                    const form = document.getElementById('ct_customer_login');
                    if (form) {
                        if (returnToCheckout) form.action = "/account/login?return_to=/checkout";
                        else form.action = "/account/login";
                        form.submit();
                    }
                } catch (e) { }
            }
        });
    } catch (e) {
        try {
            const formf = document.getElementById('ct_customer_login');
            if (formf) {
                if (returnToCheckout) formf.action = "/account/login?return_to=/checkout";
                else formf.action = "/account/login";
                formf.submit();
            }
        } catch (er) { }
    }
}

// cookie helper
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
